<template>
  <div style="height: 100%">
    <installation-thermostat
      id="thermostat"
      v-if="isLoaded"
      :installation="installation"
    ></installation-thermostat>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import InstallationThermostat from "../../../components/installations/InstallationThermostat";

export default {
  components: {
    InstallationThermostat,
  },
  name: "installation-temp",
  props: {
    id: String,
  },
  data() {
    return {
      isLoaded: false,
    };
  },
  computed: {
    ...mapState("installations", {
      installation: "current",
    }),
  },

  methods: {
    ...mapActions("installations", ["setCurrent"]),
  },

  mounted() {
    this.setCurrent(this.id)
      .then(() => {
        this.isLoaded = true;
      })
      .catch(() => {
        this.$router.push("/installations");
      });
  },
};
</script>

<style lang="scss" scoped></style>
